import React from 'react';
import styled from 'styled-components';
import {Button, EMPHASIS} from '@forecast-it/design-system';

type ComposerMode = 'reply' | 'note';

interface Props {
	fromMode: ComposerMode;
	toMode: ComposerMode;
	onKeepDraft: () => void;
	onDiscard: () => void;
	onCancel: () => void;
}

const Overlay = styled.div`
	position: fixed;
	inset: 0;
	z-index: 50;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const Backdrop = styled.div`
	position: absolute;
	inset: 0;
	background: rgb(0 0 0 / 0.4);
`;

const Dialog = styled.div`
	position: relative;
	z-index: 10;
	width: 100%;
	max-width: 24rem;
	border-radius: 8px;
	background: #ffffff;
	padding: 24px;
	box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1);
`;

const Heading = styled.h2`
	margin: 0 0 8px;
	font-size: 16px;
	line-height: 24px;
	font-weight: 500;
	color: #0f172a;
`;

const Body = styled.p`
	margin: 0 0 16px;
	${p => p.theme.sys.font?.subheading?.['2']}
	color: #475569;
`;

const Actions = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 8px;
`;

export function ConfirmModeSwitch({toMode, onKeepDraft, onDiscard, onCancel}: Props) {
	const targetLabel = toMode === 'note' ? 'Internal Note' : 'Reply';

	return (
		<Overlay>
			<Backdrop data-testid="modal-backdrop" onClick={onCancel} />
			<Dialog role="dialog" aria-labelledby="confirm-mode-switch-heading">
				<Heading id="confirm-mode-switch-heading">Switch to {targetLabel}?</Heading>
				<Body>You have unsaved content. What would you like to do?</Body>
				<Actions>
					<Button emphasis={EMPHASIS.LOW} onPress={onCancel}>
						Cancel
					</Button>
					<Button emphasis={EMPHASIS.LOW} onPress={onDiscard}>
						Switch anyway
					</Button>
					<Button emphasis={EMPHASIS.HIGH} onPress={onKeepDraft}>
						Keep draft
					</Button>
				</Actions>
			</Dialog>
		</Overlay>
	);
}
